import React from 'react';
import { Cell, Grid } from 'react-foundation'
import { Container, Content, Header, Tagline } from './Banner.style';

const Banner = () => {
  return(
    <Container>
      <Content>
        <Grid className="grid-x grid-margin-x">
          <Cell small={12}>
            <Header>Password reset</Header>
            <Tagline>To reset your password, please enter your email below.</Tagline>
          </Cell>
        </Grid>
      </Content>
    </Container>
  )
}

export default Banner;